import React, { useContext, useEffect, useState } from 'react';

import { HttpMethods, FetchContext, ApiRoutes } from '../../../contexts';
import { useAggregatedState } from '../../../../helpers';

export const LogsContext = React.createContext(null);

const { Provider } = LogsContext;
export const LogsProvider = (props) => {
    const { fetchAuthorized } = useContext(FetchContext);
    const [ state, setState ] = useAggregatedState({
        isLoadingLogs: false,
        allProjects: null
    });

    const getProjectsAsync = async (data) => {
        try {
            setState({ isLoadingLogs: true }); 
            const getProjectsApi = await fetchAuthorized(ApiRoutes.Projects.GetProjects({ year: data, includeDeleted: true, pageSize: 10000 }),
            {                    
                method: HttpMethods.GET
            }); 
    
            const bundle = await getProjectsApi.json();
            setState({ allProjects: bundle.items, isLoadingLogs: false });
        }
    
        catch (ex){
            setState({ isLoadingLogs: false }); 
            console.error(ex);
            console.error(ex.details);
        }
    }

    return (
        <Provider value={{
            state,
            getProjectsAsync
        }}>
            {props.children}
        </Provider>
    );
}